import React from 'react';
import uniqueId from 'lodash/uniqueId';
import PropTypes from 'prop-types';
import string from '../../lib/string';

const MatchText = ({ text, match }) => {
  const parts = string.splitAndInclude(text, match);
  const regExp = string.escapedRegExp(match, 'i');
  return (
    <span
      className="match_text_container"
      data-full_text={text}
    >
      {parts.map(part => (
        <span
          key={uniqueId('match-text-')}
          className={regExp.test(part) ? 'match-text' : ''}
        >
          {part}
        </span>
      ))}
    </span>
  );
};

MatchText.propTypes = {
  text: PropTypes.string.isRequired,
  match: PropTypes.string.isRequired,
};

export default MatchText;
